import * as React from 'react';

import { useReplyScrollStoreContext } from './replyScrollContext';

/**
 * Подписка на подсветку конкретного сообщения после скролла к реплаю.
 *
 * Цель хранится в сторе, не в React-стейте: иначе смена лоадера или цели
 * перерисует все сообщения в ленте. React сравнивает boolean-снимок и обновляет
 * только сообщение, у которого флаг реально меняется.
 */
export const useIsReplyScrollTarget = (messageId: string) => {
  const store = useReplyScrollStoreContext();

  const isReplyTarget = React.useSyncExternalStore(
    store.subscribe,
    () => store.getReplyTargetMessageId() === messageId,
    () => false,
  );

  return { isReplyTarget, clearReplyTargetMessage: store.clearReplyTargetMessage };
};
